<template>
  <div class="row">
    <v-card flat class="col-12 p-3 mb-5 search-box">
      <form class="row" @submit.prevent="searchForData">
        <div class="col-lg-4 py-0">
          <v-autocomplete
            v-model="search.tutorName"
            :items="tutors"
            item-text="full_name"
            item-value="id"
            :label="$t('tutorName')"
            filled
            clearable
            color="green"
            clear-icon="mdi-close-circle"
          ></v-autocomplete>
        </div>
        <div class="col-lg-4 py-0">
          <v-autocomplete
            v-model="search.studentName"
            :items="students"
            item-text="full_name"
            item-value="id"
            :label="$t('studentName')"
            filled
            clearable
            color="green"
            clear-icon="mdi-close-circle"
          ></v-autocomplete>
        </div>
        <div class="col-lg-4 py-0">
          <v-autocomplete
            :items="feedbackCreatorsList"
            v-model="search.feedbackCreator"
            filled
            item-text="name"
            item-value="value"
            :label="$t('Tutor') + ' / ' + $t('Student')"
            color="green"
            clear-icon="mdi-close-circle"
            clearable
            item-color="green"
          ></v-autocomplete>
        </div>
        <div class="col-lg-6 py-0">
          <v-autocomplete
            auto-select-first
            :items="courseTypeList"
            v-model="search.courseType"
            item-text="course_type_name"
            item-value="course_type_id"
            filled
            :menu-props="{ maxHeight: '400' }"
            :label="$t('courseType')"
            color="green"
            clear-icon="mdi-close-circle"
            clearable
            item-color="green"
          ></v-autocomplete>
        </div>
        <div class="col-lg-6 py-0">
          <v-autocomplete
            auto-select-first
            :items="programNameList"
            v-model="search.programName"
            item-text="name"
            item-value="id"
            filled
            :menu-props="{ maxHeight: '400' }"
            :label="$t('programName')"
            color="green"
            clear-icon="mdi-close-circle"
            clearable
            item-color="green"
          ></v-autocomplete>
        </div>
        <div class="col-lg-3 py-0">
          <v-dialog
            ref="classesFromDateDialog"
            width="290px"
            v-model="classesFromDateModal"
            :return-value.sync="search.classesFromDate"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :label="$t('tables.classFromDate')"
                prepend-icon="mdi-calendar"
                filled
                v-bind="attrs"
                v-on="on"
                color="green"
                clearable
                clear-icon="mdi-close-circle"
                readonly
                v-model="search.classesFromDate"
              >
              </v-text-field>
            </template>
            <v-date-picker
              v-model="search.classesFromDate"
              :max="new Date().toISOString()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="red" @click="classesFromDateModal = false">
                {{ $t("Cancel") }}
              </v-btn>
              <v-btn
                text
                color="green"
                @click="
                  $refs.classesFromDateDialog.save(search.classesFromDate)
                "
              >
                {{ $t("ok") }}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </div>
        <div class="col-lg-3 py-0">
          <v-dialog
            ref="classesToDateDialog"
            width="290px"
            v-model="classesToDateModal"
            :return-value.sync="search.classesToDate"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :label="$t('tables.classToDate')"
                prepend-icon="mdi-calendar"
                filled
                v-bind="attrs"
                v-on="on"
                color="green"
                clearable
                clear-icon="mdi-close-circle"
                readonly
                v-model="search.classesToDate"
              >
              </v-text-field>
            </template>
            <v-date-picker
              v-model="search.classesToDate"
              :max="new Date().toISOString()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="red" @click="classesToDateModal = false">
                {{ $t("Cancel") }}
              </v-btn>
              <v-btn
                text
                color="green"
                @click="$refs.classesToDateDialog.save(search.classesToDate)"
              >
                {{ $t("ok") }}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </div>
        <div class="col-lg-3 py-0">
          <v-dialog
            ref="feedbacksFromDateDialog"
            width="290px"
            v-model="feedbacksFromDateModal"
            :return-value.sync="search.feedbacksFromDate"
            class="col-lg-3 py-0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :label="$t('tables.feedbackFromDate')"
                prepend-icon="mdi-calendar"
                filled
                v-bind="attrs"
                v-on="on"
                color="green"
                clearable
                clear-icon="mdi-close-circle"
                readonly
                v-model="search.feedbacksFromDate"
              >
              </v-text-field>
            </template>
            <v-date-picker
              v-model="search.feedbacksFromDate"
              :max="new Date().toISOString()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="red" @click="feedbacksFromDateModal = false">
                {{ $t("Cancel") }}
              </v-btn>
              <v-btn
                text
                color="green"
                @click="
                  $refs.feedbacksFromDateDialog.save(search.feedbacksFromDate)
                "
              >
                {{ $t("ok") }}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </div>
        <div class="col-lg-3 py-0">
          <v-dialog
            ref="feedbacksToDateDialog"
            width="290px"
            v-model="feedbacksToDateModal"
            :return-value.sync="search.feedbacksToDate"
            class="col-lg-3 py-0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :label="$t('tables.feedbackToDate')"
                prepend-icon="mdi-calendar"
                filled
                v-bind="attrs"
                v-on="on"
                color="green"
                clearable
                clear-icon="mdi-close-circle"
                readonly
                v-model="search.feedbacksToDate"
              >
              </v-text-field>
            </template>
            <v-date-picker
              v-model="search.feedbacksToDate"
              :max="new Date().toISOString()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="red" @click="feedbacksToDateModal = false">
                {{ $t("Cancel") }}
              </v-btn>
              <v-btn
                text
                color="green"
                @click="
                  $refs.feedbacksToDateDialog.save(search.feedbacksToDate)
                "
              >
                {{ $t("ok") }}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </div>
        <div
          class="col py-0 d-flex justify-content-center md-justify-content-end align-items-center mb-1"
        >
          <v-btn color="success" type="submit" class="me-4">
            {{ $t("search") }}
          </v-btn>
          <v-btn color="error" @click="clearSearch">
            {{ $t("clear") }}
          </v-btn>
        </div>
      </form>
    </v-card>
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";

export default {
  name: "FeedbacksFilter",
  mixins: [GlobalMixin],
  props: ["currentIns"],
  data() {
    return {
      tutors: [],
      students: [],

      courseTypeList: [],
      programNameList: [],

      // Search Parameters
      search: {
        tutorName: "",
        studentName: "",
        feedbackCreator: "",
        classesFromDate: "",
        classesToDate: "",
        feedbacksFromDate: "",
        feedbacksToDate: "",
        courseType: "",
        programName: "",
      },

      feedbackCreatorsList: [
        { value: "tutor_feedback", name: "Tutor" },
        { value: "student_feedback", name: "Student" },
      ],

      classesFromDateModal: false,
      classesToDateModal: false,
      feedbacksFromDateModal: false,
      feedbacksToDateModal: false,
    };
  },
  async mounted() {
    await this.getAllPrograms();
    await this.getAllCourseTypes();
    this.getAllTutors();
    this.getAllStudents();
  },
  methods: {
    async getAllPrograms() {
      await this.axios(
        `${process.env.VUE_APP_APIEndPoint}tutor/programs/`,
        this.headers
      )
        .then((res) => {
          this.programNameList = res.data;
        })
        .catch((err) => this.formatErrors(err));
    },
    async getAllCourseTypes() {
      await this.axios(
        `${process.env.VUE_APP_APIEndPoint}tutor/course_types/`,
        this.headers
      )
        .then((res) => {
          this.courseTypeList = res.data;
        })
        .catch((err) => this.formatErrors(err));
    },

    getAllTutors() {
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}tutor/operator/listing/`,
          { institute: this.currentIns, limit: 1000, status: "approved" },
          this.headers
        )
        .then(
          (tutors) =>
            (this.tutors = tutors.data.data.tutors.sort((a, b) =>
              a.full_name > b.full_name ? 1 : -1
            ))
        )
        .catch((err) => this.formatErrors(err));
    },

    getAllStudents() {
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}auth/students_list/`,
          { institute: this.currentIns, limit: 1000 },
          this.headers
        )
        .then(
          (students) =>
            (this.students = students.data.students.sort((a, b) =>
              a.full_name > b.full_name ? 1 : -1
            ))
        )
        .catch((err) => this.formatErrors(err));
    },

    /**
     * Search for values in database
     */
    searchForData() {
      this.$emit("searchForData", this.search);
      console.log(this.search);
    },

    /**
     * Clear all search values and reset table
     */
    clearSearch() {
      this.search = {
        tutorName: "",
        studentName: "",
        feedbackCreator: "",
        classesFromDate: "",
        classesToDate: "",
        feedbacksFromDate: "",
        feedbacksToDate: "",
        courseType: "",
        programName: "",
      };
      this.$emit("resetSearch");
    },
  },
  watch: {
    // Watch for changes of currentIns
    currentIns(newVal) {
      if (!newVal) return;
      this.getAllCourseTypes();
      this.getAllPrograms();
      this.getAllTutors();
      this.getAllStudents();
    },
  },
};
</script>

<style lang="scss" scoped></style>
